var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewspaperBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3921_1114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 2.5L16.9417 3.89167L15.5584 2.5L14.1667 3.89167L12.7751 2.5L11.3917 3.89167L10.0001 2.5L8.60841 3.89167L7.22508 2.5L5.83341 3.89167L4.44175 2.5L3.05841 3.89167L1.66675 2.5V15.8333C1.66675 16.75 2.41675 17.5 3.33341 17.5H16.6667C17.5834 17.5 18.3334 16.75 18.3334 15.8333V2.5ZM9.16675 15.8333H3.33341V10.8333H9.16675V15.8333ZM16.6667 15.8333H10.8334V14.1667H16.6667V15.8333ZM16.6667 12.5H10.8334V10.8333H16.6667V12.5ZM16.6667 9.16667H3.33341V6.66667H16.6667V9.16667Z",
    fill: "#404040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3921_1114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaperBlack);
export default __webpack_public_path__ + "static/media/newspaper_black.78c5ad6731531124b57f21abcd89c271.svg";
export { ForwardRef as ReactComponent };